module.exports = __webpack_public_path__ + "static/img/daiyunying_fangan.93c30459.png";